// Import React helper
import {
    // Import createContext
    createContext,
} from "react";



// Create and export the app config context
export const AppConfigContext = createContext(null);